import { useAtomValue, useSetAtom } from 'jotai'
import { debounce } from 'lodash-es'
import Image from 'next/image'
import { useCallback, useMemo, useState } from 'react'

import { globalState, storageDgTourCardTooltipClicked, storageTooltipClicked } from '@/atoms'
import { sendEventLog } from '@/features/log/log.fn'
import MyLogDefinition from '@/features/log/log.my'
import { useOpenService } from '@/hooks'
import { schemeUrl } from '@/utils'

import * as styles from './userProfile.css'

export interface UserProfileProps {
  loginAuthType: string
  image: string | null
  name: string
  mdn: string
  tid: string
  isVerified: boolean
}

export function UserProfile(props: UserProfileProps) {
  const { loginAuthType, image, name, mdn, tid, isVerified } = props
  const openService = useOpenService()
  const globalStateValue = useAtomValue(globalState)
  const _dgTourCard = globalStateValue.MY_DGTOURCARD
  const _isDgTourTooltipClosed = useAtomValue(storageDgTourCardTooltipClicked)
  const setTooltipClickedStorageValue = useSetAtom(storageTooltipClicked)
  const { action_id } = MyLogDefinition.my
  const [isImageError, setIsImageError] = useState(false)

  const displayNickName = useMemo(() => {
    if (name) {
      return name
    } else {
      if (loginAuthType === 'None') {
        return '닉네임 등록하기'
      } else if (loginAuthType === 'MDC' || loginAuthType === 'MCI') {
        if (mdn.length) {
          return mdn
        }
      } else if (loginAuthType === 'TID') {
        if (tid) {
          return tid
        }
      }
      return '닉네임 등록하기'
    }
  }, [loginAuthType, name, mdn, tid])

  const callMoveToProfileEdit = useMemo(
    () =>
      debounce(
        () => {
          const custom = {
            unit: isVerified !== null && !isVerified ? 'N' : 'Y',
          }
          setTooltipClickedStorageValue(true)
          sendEventLog(action_id?.tapMyinfo, custom)
          openService(schemeUrl.profile)
        },
        1000,
        { leading: true, trailing: false }
      ),
    [openService, isVerified, action_id?.tapMyinfo, setTooltipClickedStorageValue]
  )

  const moveToProfileEdit = useCallback(() => {
    callMoveToProfileEdit()
  }, [callMoveToProfileEdit])

  return (
    <div className={styles.wrapper}>
      <button onClick={moveToProfileEdit}>
        <Image
          width={56}
          height={56}
          style={{ borderRadius: '50%' }}
          src={
            image && !isImageError
              ? image
              : require('../../../../assets/images/profile_s.svg').default
          }
          alt={image ? '사용자 제공 이미지' : '기본 이미지'}
          unoptimized={Boolean(image)}
          priority={true}
          onError={() => setIsImageError(true)}
        />
      </button>

      <div className={styles.userInfoWrapper}>
        <button
          className={styles.nameBtn}
          onClick={moveToProfileEdit}
        >
          <p
            data-testid="profile_name"
            className={`${styles.name} ${(!displayNickName.length || loginAuthType === 'None') && styles.nameUnregistered} ${isVerified ? styles.nameWidthVariants.verified : styles.nameWidthVariants.notVerified}`}
          >
            {displayNickName}
          </p>
          {!isVerified && (
            <div
              className={styles.unVerifiedTag}
              data-testid="profile_verified"
            >
              미인증
            </div>
          )}
          <Image
            src={require('../../../../assets/images/ico_pen_write.svg').default}
            alt=""
          />
        </button>
      </div>

      {/*{(isDgTourTooltipClosed || !dgTourCard?.isShow) && (*/}
      {/*{*/}
      {/*  <Tooltip*/}
      {/*    storageKey={storageTooltipClicked}*/}
      {/*    content={"프로필을 설정하고 나를 표현해보세요!"}*/}
      {/*    viewActionId={action_id?.viewProfileTooltip}*/}
      {/*    clickActionId={action_id?.tapProfileTooltip}*/}
      {/*    // tooltipData={tooltipData}*/}
      {/*  />*/}
      {/*}*/}

      {/*)}*/}
    </div>
  )
}
